export const PaymentType = {
  CASH: 1,
  CREDIT: 2,
  CREDIT_CARD: 3,
  BANK_TRANSFER: 4,
  CARD: 6,
  MULTIPLE: 7,
  LINK: 100,
}

const paymentTypesNames: Record<number, string> = {
  1: 'Efectivo',
  2: 'Crédito',
  4: 'Transferencia',
  6: 'Tarjeta',
  7: 'Múltiple',
}

const getPaymentTypes = (): ISelect[] => {
  const paymentFilter = [PaymentType.CREDIT_CARD, PaymentType.LINK]

  return Object.keys(PaymentType)
    .filter(type => !paymentFilter.includes(PaymentType[type]))
    .map(type => {
      const key = PaymentType[type]

      return {
        value: key,
        label: paymentTypesNames[key],
      }
    })
}

const basicMethodPayments: ISelect[] = [
  {
    label: paymentTypesNames[PaymentType.CASH],
    value: PaymentType.CASH,
  },
  {
    label: paymentTypesNames[PaymentType.CREDIT],
    value: PaymentType.CREDIT,
  },
  {
    label: paymentTypesNames[PaymentType.BANK_TRANSFER],
    value: PaymentType.BANK_TRANSFER,
  },
  {
    label: paymentTypesNames[PaymentType.CARD],
    value: PaymentType.CARD,
  },
]

const ignoreAccountTypes = [6, 7, 8, 13, 39]

export { getPaymentTypes, basicMethodPayments, ignoreAccountTypes }
